import React from 'react'

interface BackgroundProps {
  children: React.ReactNode
}

const Background: React.FC<BackgroundProps> = ({ children }) => {
  return <>{children}</>
}

export default Background
